import { gql } from '@apollo/client';

export const UPDATE_ADMIN = gql`
   mutation UpdateAdmin($input: UpdateAdminDTO!, $updateAdminId: String!) {
  updateAdmin(input: $input, id: $updateAdminId) {
    message
    pagination {
      total
      hasNextPage
    }
    admin {
      _id
      name
      email
      dob
      address
      role
      access
      createdAt
      lastLoginAt
    }
  }
}
`;

export const DELETE_ADMIN = gql`
    mutation ($id: String!) {
        removeAdmin(id: $id) {
            message
            admin {
                _id
            }
        }
    }
`;

export const DISABLE_ADMIN = gql`
    mutation DisableAdmin($id: String!) {
        disableAdmin(id: $id) {
            message
            admin {
                _id
            }
        }
    }
`;
